import { selectSelectedTicketIds } from 'selectors/ticket_list/base'
import { createBasicSelector } from 'util/redux'
import { selectConversationsByIds } from './selectConversationsByIds'

export const selectConversationsBySelectedTicketIds = createBasicSelector(
  selectSelectedTicketIds,
  state => state,
  (ticketIds, state) => selectConversationsByIds(state, ticketIds)
)
